module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/353.7e08edd7.png";